import React, { useRef } from "react";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import { FaCaretDown } from "react-icons/fa";
import "./style.scss";

interface Props {
  values?: {
    title: string;
    id: any;
  }[];
  label?: string;
  className?: string;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  value?: string;
  onChange?(param: string): void;
  width?: number;
  additionalItems?: {
    title: string;
    id: any;
  }[];
  onAdditionalItemClick?(item: string): void;
}

export const Select: React.FC<Props> = ({
  label,
  className,
  values = [],
  placeholder,
  isLoading = false,
  disabled = false,
  value = "",
  onChange = () => {},
  width,
  additionalItems = [],
  onAdditionalItemClick = () => {},
}) => {
  const actionRef = useRef<HTMLDivElement>(null);

  const handleChange = (param: any) => {
    actionRef.current && actionRef.current.blur();
    onChange(param);
  };

  return (
    <div
      className={classNames("select-control", className)}
      style={{ width: width || "auto" }}
    >
      {label && <div className="select-control__label">{label}</div>}
      <div
        className="select-control__container"
        ref={actionRef}
        tabIndex={disabled ? undefined : 1}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={classNames("select-control__main", {
            active: value,
          })}
        >
          <div className="flex-1 d-flex justify-content-between">
            {value ? (
              <span className="my-auto">
                {
                  values.find((item) =>
                    +item.id ? +item.id === +value : item.id === value,
                  )?.title
                }
              </span>
            ) : (
              <span className="my-auto select-control__placeholder">
                {placeholder}
              </span>
            )}
          </div>
          <FaCaretDown className="select-control__arrow" />
        </div>
        <div className={classNames("select-control__menu")}>
          {isLoading ? (
            <ClipLoader
              size={40}
              color="#297D4A"
              cssOverride={{
                display: "block",
                margin: "20px auto",
              }}
            />
          ) : values.length > 0 ? (
            values.map(({ title, id: itemVal }, key) => {
              return (
                <div
                  className={classNames("select-control__menu-item", {
                    active: value === itemVal,
                  })}
                  key={`${key}key`}
                  onClick={() => handleChange(itemVal)}
                >
                  <span>{title}</span>
                </div>
              );
            })
          ) : (
            <div className="my-3 text-gray text-center">Empty</div>
          )}
          {additionalItems.length > 0 && (
            <div className="select-control__separator"></div>
          )}
          {additionalItems.map(({ title, id }) => {
            return (
              <div
                className={classNames("select-control__menu-item")}
                key={`${id}addr`}
                onClick={() => onAdditionalItemClick(id)}
              >
                <span>{title}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
